import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import { toJS, comparer } from 'mobx';
export class AsyncDataSource {
    constructor(operations, idSelector, withCache) {
        Object.defineProperty(this, "idSelector", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "operations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "withCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cached", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cancelation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.operations = operations;
        this.idSelector = idSelector;
        this.withCache = withCache;
    }
    async getData(state) {
        if (this.cancelation) {
            this.cancelation.cancel();
        }
        if (this.withCache && this.cached && comparer.structural(this.cached.state, state)) {
            return cloneDeep(this.cached.result);
        }
        this.cancelation = axios.CancelToken.source();
        const result = toJS(await this.operations.get(state, this.cancelation.token));
        this.cancelation = undefined;
        this.cached = { state, result };
        return cloneDeep(result);
    }
    async addData(row, index) {
        if (!this.operations.add) {
            throw 'missing add function in the operations';
        }
        const result = await this.operations.add(row, index);
        this.cached = undefined;
        return result;
    }
    async updateData(id, changes) {
        if (!this.operations.update) {
            throw 'missing update function in the operations';
        }
        await this.operations.update(id, changes);
        this.cached = undefined;
    }
    async removeData(id) {
        if (!this.operations.remove) {
            throw 'missing remove function in the operations';
        }
        const result = await this.operations.remove(id);
        this.cached = undefined;
        return result;
    }
}
//# sourceMappingURL=async-data-source.js.map